import Alpine from "alpinejs";
import registerServiceWorker from "./components/service-worker-registration";
import focus from "@alpinejs/focus";
import modal from "./components/modal";
import publicMap from "./components/public-map";

Alpine.plugin(focus);
Alpine.data("modal", modal);
Alpine.data("publicMap", publicMap);
window.Alpine = Alpine;
registerServiceWorker();
Alpine.start();
